<template>
  <div v-bind:id="chartId" class="chart"></div>
</template>
<script>
export default {
  name: 'randerChart',
  data () {
    return {
      chart: null,
      basisOption: {
        title: {
          text: '',
          // textStyle: {
          //   fontSize: '14',
          //   fontWeight: '500'
          // },
          left: 'center' // title 组件离容器左侧的距离。
        },
        tooltip: {},
        legend: {},
        grid: {// 网格
          left: '10',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        radar: {
          shape: 'polygon',
          splitNumber: 5,
          indicator: [
            {
              name: '质量'
            },
            {
              name: '效率'
            },
            {
              name: '产量'
            },
            {
              name: '有效\n时长'
            }
          ],
          center: ['50%', '55%'],
          radius: ['10%', '70%'],
          splitArea: {
            areaStyle: {
              color: ['#fff']
            }
          },
          splitLine: {
            lineStyle: {
              // 使用深浅的间隔色
              // color: ['#aaa', '#ddd'],
              type: 'dashed'
            }
          },
          axisLine: {
            show: false
          }
        },
        series: [
          {
            name: '',
            type: 'radar',
            label: {
              show: true
            },
            areaStyle: {
              color: '#334FC5'
            },
            itemStyle: {
              color: '#334FC5'
            },
            lineStyle: {
              color: '#4D5EAA',
              width: 2
            },
            symbolSize: 8,
            data: []
          }
        ],
        backgroundColor: '#fff',
        color: [
          '#334FC5',
          '#ff4c62',
          '#06B0FF',
          '#00CE69',
          '#FF7443',
          '#7A4CF2',
          '#9BCB2A',
          '#65648C',
          '#EF938A',
          '#69D9F0 ',
          '#E1B139',
          '#AB9FDC'
        ]
      }
    }
  },
  props: {
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    load: {
      type: Boolean,
      default: false
    },
    clear: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    chartId () {
      return 'randerChart' + Math.random() * 100000
    }
  },
  activated () {
    this.chartResize()
  },
  mounted () {
    setTimeout(() => {
      this.initChart()
    })
    // 自适应
    window.addEventListener('resize', () => {
      this.chartResize()
    })
  },
  watch: {
    option (val) {
      // 将传递来的options与已有的合并
      this.chart.setOption(val)
    },
    load (val) {
      this.setLoading(val)
    },
    clear (val) {
      this.clearChart(val)
    }
  },
  methods: {
    initChart () {
      // 基于准备好的dom，初始化echarts实例
      let chart = this.$echarts.init(document.getElementById(this.chartId))

      // 绘制图表
      chart.setOption(this.basisOption)
      this.chart = chart
      this.setLoading(this.load)
    },
    chartResize () {
      this.chart && this.chart.resize()
    },
    setLoading (val = false) {
      if (this.chart) {
        if (val) {
          this.chart.showLoading({
            text: '',
            color: '#409EFF',
            lineWidth: 2,
            textStyle: {
              fontSize: 20
            }
          })
        } else {
          this.chart.hideLoading()
        }
      }
    },
    clearChart (val = false) {
      if (val) {
        this.chart.setOption(this.basisOption, true)// 不跟之前设置的 option 进行合并
      }
    }
  }
}
</script>
<style lang="less" scoped>
.chart {
  height: 480px;
  width: 100%;
  // border: 1px solid red;
}
</style>
